// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../lastDayOfISOWeek/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var lastDayOfISOWeek = convertToFP(fn, 1);
export default lastDayOfISOWeek;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/lastDayOfISOWeek/index.js
// module id = 949
// module chunks = 0